<template>
  <transition name='fade'>
    <div
      class="modal print_box"
      v-if='visible'
    >
      <div class="print_content">
        <div
          class="froala_editor fr-box fr-ltr fr-basic fr-top print_descrip"
          id="print_content"
        >
          <div class="fr-wrapper">
            <div class="fr-element fr-view">
              <div
                class="print_descrip_title"
                style="margin-bottom:20px;color:#303133;font-weight:bold;font-size:20px;text-align:center;box-sizing:border-box;width:100%;padding-left:0px;padding-right:0px;"
              >{{articleObj.title}}</div>
              <div
                class="print_member"
                style="display:flex;margin-bottom:10px;padding-left:0px;box-sizing:border-box;"
                v-if="articleObj.doc_type!='document' && isArticleBaseinfo"
              >
                <div
                  class="print_member_info"
                  style="width:33%;"
                >
                  <span style="color:#606266;font-size:11pt;">作者：</span>
                  <span style="color:#606266;font-size:11pt;">{{articleObj.author}}</span>
                </div>
                <div
                  class="print_member_info"
                  style="width:33%;"
                >
                  <span style="color:#606266;font-size:11pt;">校对人员：</span>
                  <span style="color:#606266;font-size:11pt;">{{articleObj.check_editor}}</span>
                </div>

                <div
                  class="print_member_info"
                  style="width:33%;"
                >
                  <span style="color:#606266;font-size:11pt;">发文机构：</span>
                  <span style="color:#606266;font-size:11pt;">{{articleObj.org_publish}}</span>
                </div>

              </div>
              <div
                class="print_member"
                style="display:flex;margin-bottom:10px;padding-left:0px;box-sizing:border-box;"
                v-if="articleObj.doc_type!='document' && isArticleBaseinfo"
              >
                <div
                  class="print_member_info"
                  style="width:33%;"
                >
                  <span style="color:#606266;font-size:11pt;">编辑：</span>
                  <span style="color:#606266;font-size:11pt;">{{articleObj.editor}}</span>
                </div>
                <div
                  class="print_member_info"
                  style="width:33%;"
                >
                  <span style="color:#606266;font-size:11pt;">责任编辑：</span>
                  <span style="color:#606266;font-size:11pt;">{{articleObj.duty_editor}}</span>
                </div>

                <div
                  class="print_member_info"
                  style="width:33%;"
                >
                  <span style="color:#606266;font-size:11pt;">审签：</span>
                  <span style="color:#606266;font-size:11pt;">{{articleObj.sign_audit}}</span>
                </div>

              </div>
              <div
                class="print_member"
                style="display:flex;margin-bottom:10px;padding-left:0px;box-sizing:border-box;"
                v-if="articleObj.doc_type!='document' && isArticleBaseinfo"
              >
                <div
                  class="print_member_info"
                  style="width:33%;"
                >
                  <span style="color:#606266;font-size:11pt;">编审：</span>
                  <span style="color:#606266;font-size:11pt;">{{articleObj.editor_audit}}</span>
                </div>
                <div
                  class="print_member_info"
                  style="width:33%;"
                >
                  <span style="color:#606266;font-size:11pt;">终审：</span>
                  <span style="color:#606266;font-size:11pt;">{{articleObj.final_audit}}</span>
                </div>
                <div
                  class="print_member_info"
                  style="width:33%;"
                >
                  <span style="color:#606266;font-size:11pt;">责任审核：</span>
                  <span style="color:#606266;font-size:11pt;">{{articleObj.duty_audit}}</span>
                </div>
              </div>
              <div
                class="print_member"
                style="display:flex;margin-bottom:10px;padding-left:0px;box-sizing:border-box;"
                v-if="articleObj.doc_type!='document' && isArticleBaseinfo"
              >
                <div
                  class="print_member_info"
                  style="width:100%;"
                >
                  <span style="color:#606266;font-size:11pt;">稿件来源：</span>
                  <span style="color:#606266;font-size:11pt;">{{articleObj.source}}</span>
                </div>
              </div>
              <div
                class="print_member"
                style="display:flex;margin-bottom:10px;padding-left:0px;box-sizing:border-box;"
                v-if="articleObj.doc_type!='document' && isArticleBaseinfo"
              >
                <span
                  class="keywords_title"
                  style="color:#606266;font-size:11pt;"
                >关键词：</span>
                <div
                  class="keywords"
                  style="width:90%;word-break:break-all;clear:both;"
                >
                  <span
                    v-for="item in articleObj.keywords"
                    style="color:#606266;font-size:11pt;margin-right:10px;margin-bottom:10px;float:left;"
                  >{{item}}</span>
                </div>
              </div>
              <div
                class="print_member"
                style="display:flex;margin-bottom:10px;padding-left:0px;box-sizing:border-box;"
                v-if="articleObj.doc_type!='document' && isArticleBaseinfo"
              >
                <span
                  class="summary_title"
                  style="color:#606266;font-size:11pt;line-height:20px;"
                >摘要：</span>
                <div
                  class="keywords summary"
                  style="width:90%;word-break:break-all;"
                >
                  <span style="color:#606266;font-size:11pt;line-height:20px;">{{articleObj.summary}}</span>
                </div>
              </div>

              <div
                class="print_member"
                style="display:flex;margin-bottom:10px;padding-left:0px;box-sizing:border-box;"
                v-if="articleObj.doc_type!='document' && isArticleBaseinfo"
              >
                <span
                  class="summary_title"
                  style="color:#606266;font-size:11pt;line-height:20px;"
                >口播：</span>
                <div
                  class="keywords summary"
                  style="width:90%;word-break:break-all;"
                >
                  <span style="color:#606266;font-size:11pt;line-height:20px;">{{articleObj.dialogue_text}}</span>
                </div>
              </div>

              <div
                class="print_member"
                style="display:flex;margin-bottom:14px;padding-left:0px;box-sizing:border-box;"
                v-if="articleObj.doc_type!='document' && isArticleBaseinfo"
              >
                <span
                  class="keywords_title"
                  style="color:#606266;font-size:11pt;"
                >标签：</span>
                <div
                  class="keywords"
                  style=" flex:1;word-break:break-all;clear:both;padding-right:0px;"
                >
                  <span
                    v-for="item in articleObj.tags"
                    style="color:#606266;font-size:11pt;margin-right:10px;margin-bottom:10px;float:left;"
                  >{{item}}</span>
                </div>
              </div>
              <div
                class="print_article"
                style="width:100%;padding-left:0px;padding-right:0px;box-sizing:border-box;display:flex;justify-content:center;"
              >
                <div
                  v-html="articleObj.content"
                  style="border-top:1px solid #979797;padding-top:30px;"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div class="sure_print">
          <el-button
            type="primary"
            style="margin-right:30px;"
            @click.native='surePrint()'
          >确认</el-button>
          <el-button
            type="info"
            @click.native='closeBox()'
          >取消</el-button>
        </div>
      </div>

      <div
        class="more_opacity"
        element-loading-text="跳转中,请稍后"
        v-loading='jumpLoading'
      ></div>

    </div>
  </transition>
</template>

<script>

import * as api from '../../../api'

export default {
  name: 'printview',
  data () {
    return {
      visible: false,
      num: 20,
      arr: 100,
      articleObj: '',
      articleType: '',
      jumpLoading: true,
      isArticleBaseinfo: true
    }
  },
  mounted () {
    this.$root.eventHub.$on('printArticleModel', (data, isArticleBaseinfo, type) => {
      this.visible = true
      this.articleObj = data
      this.articleType = type
      this.isArticleBaseinfo = isArticleBaseinfo
      var self = this
      this.$nextTick(() => {
        setTimeout(function () { self.surePrint(); self.visible = false }, 2000);
      })

    })


  },
  destroyed () {
    this.$root.eventHub.$off('printArticleModel')
  },
  components: {

  },
  methods: {
    closeBox () {
      this.visible = false
    },
    surePrint () {
      if (this.articleType === 'printArticle') {
        try {
          var self = this
          $("#print_content").print({
            //Use Global styles
            globalStyles: false,
            //Add link with attrbute media=print
            stylesheet: 'https://intellieditor.oss-cn-qingdao.aliyuncs.com/editor/v1.5.2/sdk.editor1.5.2.css',
            mediaPrint: false,
            //Print in a hidden iframe
            iframe: true,
            //Don't print this
            noPrintSelector: "",
            //Add this at top
            prepend: "",
            //Add this on bottom
            append: "",
            //Log to console when printing is done via a deffered callback
            deferred: $.Deferred().done(function () {
              self.visible = false
            })
          })
        } catch (error) {
          //兼容c端
          printJS({
            printable: 'print_content',
            type: 'html',
            scanStyles: false,
            css: 'https://intellieditor.oss-cn-qingdao.aliyuncs.com/editor/v1.5.2/sdk.editor1.5.2.css'
          })
        }
      }
    }

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
.print_box
  z-index 1001

  .print_content
    position relative
    box-sizing border-box
    width 800px
    height 90%
    background rgba(255, 255, 255, 1)
    box-shadow 0px 0px 6px 1px rgba(0, 0, 0, 0.1)

    .print_descrip
      overflow auto
      width 100%
      height 90%

    .sure_print
      position absolute
      bottom 20px
      left 0
      display flex
      justify-content center
      align-items center
      width 100%

      button
        height 36px
        line-height 0

  .more_opacity
    position fixed
    top 0
    left 0
    z-index 1002
    width 100%
    height 100%
    background #999

@media (min-width: 992px)
  .fr-box.fr-document .fr-wrapper
    padding 0px
    min-width 100px
    background #fff
    text-align center

@media (min-width: 992px)
  .fr-box.fr-document .fr-wrapper .fr-element
    margin-top 0px !important
    margin-bottom 0 !important
    padding 0 !important
    min-height 100px !important
    width 100% !important

@media (min-width: 992px)
  .fr-box.fr-document
    min-width 0
</style>